module.exports = __webpack_public_path__ + "static/media/our_clients_responsive_one.111bfe20.png";